export const layoutWrapper = {
  margin: 'auto',
  height: '100%',
  display: 'flex',
  flexDirection: 'column'
};
